// extracted by mini-css-extract-plugin
module.exports = {"SmallChart":"SmallChart_SmallChart__6qOkD"};